var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookshelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 151,
    viewBox: "0 0 70 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9038 33.8132L69.5872 43.6731V118.095L52.9038 108.244V33.8132Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 150.227L69.5872 119.605V118.095L0.421793 138.866L0.412819 140.394L17.1051 150.227Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 148.717L69.5872 118.095L52.9038 108.244L0.421791 138.866L17.1051 148.717Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4436 124.09L40.0167 131.316L63.7628 117.654L51.1897 110.428L27.4436 124.09Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4564 124.899L35.9782 130.678L59.7244 117.016L50.2115 111.237L26.4564 124.899Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.082 130.148V140.709L33.0077 134.92V124.251L23.082 130.148Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1013 135.271V137.23L30.9885 133.797V131.774L25.1013 135.271Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5192 123.982V134.552L23.0821 140.709V130.148L12.5192 123.982Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0077 124.251L22.4449 118.095L12.5192 123.982L23.0821 130.148L33.0077 124.251Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 131.622L69.5872 100.999V99.4892L0.421791 120.261V121.762L17.1051 131.622Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 130.112L69.5872 99.4892L52.9038 89.6383L0.421791 120.261L17.1051 130.112Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0962 118.93L18.4962 126.328L9.90769 121.384L22.5077 113.987L31.0962 118.93Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0962 116.872L18.4962 124.269L9.90769 119.326L22.5077 111.929L31.0962 116.872Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5641 102.437L51.6564 108.262L37.7103 100.109L47.609 94.2672L61.5641 102.437Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6564 105.934L61.5282 100.118C62.2192 99.7139 62.4256 100.244 62.4256 100.81C62.4819 101.143 62.4237 101.485 62.2607 101.781C62.0977 102.076 61.8395 102.308 61.5282 102.437L51.6564 108.262L37.7103 100.172C38.0327 99.9923 38.2919 99.717 38.4525 99.3841C38.6131 99.0511 38.6673 98.6767 38.6077 98.3118L51.6564 105.934Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5641 100.118L47.609 91.9392L37.7103 97.7905L51.6564 105.934L61.5641 100.118Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2103 91.8134C48.1102 91.7819 48.004 91.7752 47.9008 91.794C47.7976 91.8128 47.7005 91.8565 47.6179 91.9212L37.7462 97.7455L38.6436 98.2399L51.6744 105.898L61.5462 100.073C61.6252 100.012 61.7173 99.9695 61.8153 99.9493C61.9133 99.929 62.0146 99.9315 62.1115 99.9566L48.2103 91.8134Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4641 99.3454L51.6564 107.066L61.5641 101.242",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.859 111.425L35.9513 117.25L22.0051 109.097L31.9038 103.255L45.859 111.425Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9513 114.922L45.8231 109.106C46.5141 108.702 46.7205 109.232 46.7205 109.799C46.7767 110.131 46.7186 110.474 46.5556 110.769C46.3926 111.065 46.1344 111.296 45.8231 111.425L35.9513 117.25L22.0051 109.16C22.3276 108.98 22.5868 108.705 22.7474 108.372C22.908 108.039 22.9622 107.665 22.9026 107.3L35.9513 114.922Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.859 109.106L31.9038 100.927L22.0051 106.779L35.9513 114.922L45.859 109.106Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5051 100.801C32.4051 100.77 32.2989 100.763 32.1957 100.782C32.0925 100.801 31.9954 100.845 31.9128 100.909L22.041 106.734L22.9385 107.228L35.9692 114.886L45.841 109.062C45.9201 109 46.0122 108.958 46.1102 108.937C46.2082 108.917 46.3095 108.92 46.4064 108.945L32.5051 100.801Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.759 108.333L35.9513 116.054L45.859 110.23",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 113.016L69.5872 82.3939V80.8839L0.421791 101.655V103.156L17.1051 113.016Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 111.506L69.5872 80.8839L52.9038 71.0329L0.421791 101.655L17.1051 111.506Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8641 76.8842V83.7331L65.45 81.0457V74.1518L60.8641 76.8842Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9821 74.0349V80.8749L60.8641 83.7331V76.8842L55.9821 74.0349Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9821 74.0349V80.8749L60.8641 83.7331V76.8842L55.9821 74.0349Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 74.1518L60.5679 71.3115L55.9821 74.0349L60.8641 76.8841L65.45 74.1518Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9769 86.4205V87.8766L57.9026 82.0793V80.5154L47.9769 86.4205Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 80.2547V81.7108L47.9769 87.8766V86.4205L37.4141 80.2547Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9026 80.5153L47.3397 74.3675L37.4141 80.2547L47.9769 86.4205L57.9026 80.5153Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9218 84.0657V96.604L42.8346 94.339V81.7288L38.9218 84.0657Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1333 85.279V94.1683L41.6231 93.3324V84.3802L40.1333 85.279Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4821 79.6974V92.2089L38.9218 96.6041V84.0657L31.4821 79.6974Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8346 81.7287L35.4038 77.3515L31.4821 79.6974L38.9218 84.0657L42.8346 81.7287Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86.3936V98.905L38.9218 96.6041V84.0657L35 86.3936Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2115 87.589V96.4692L37.7103 95.6333V86.6812L36.2115 87.589Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5692 82.0164V94.5188L35 98.905V86.3936L27.5692 82.0164Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9218 84.0657L31.4821 79.6974L27.5692 82.0164L35 86.3936L38.9218 84.0657Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0872 88.7125V101.215L35 98.905V86.3846L31.0872 88.7125Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2987 89.9079V98.7882L33.7885 97.9612V89.0091L32.2987 89.9079Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6564 84.3443V96.8378L31.0872 101.215V88.7125L23.6564 84.3443Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86.3846L27.5692 82.0164L23.6564 84.3443L31.0872 88.7125L35 86.3846Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5359 92.6493V105.143L28.4577 102.86V90.3214L24.5359 92.6493Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7474 93.8447V102.725L27.2462 101.889V92.9369L25.7474 93.8447Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 88.2721V100.775L24.5359 105.143V92.6493L17.1051 88.2721Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 88.2721V100.775L24.5359 105.143V92.6493L17.1051 88.2721Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4577 90.3214L21.0269 85.9532L17.1051 88.2721L24.5359 92.6493L28.4577 90.3214Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 94.4109L69.5872 63.7885V62.2785L0.421791 83.05V84.551L17.1051 94.4109Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 92.901L69.5872 62.2785L52.9038 52.4186L0.421791 83.05L17.1051 92.901Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0526 86.8609C24.232 86.8609 28.4308 84.6235 28.4308 81.8636C28.4308 79.1036 24.232 76.8662 19.0526 76.8662C13.8731 76.8662 9.67436 79.1036 9.67436 81.8636C9.67436 84.6235 13.8731 86.8609 19.0526 86.8609Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0526 84.7847C23.0871 84.7847 26.3577 83.4769 26.3577 81.8636C26.3577 80.2503 23.0871 78.9424 19.0526 78.9424C15.0181 78.9424 11.7474 80.2503 11.7474 81.8636C11.7474 83.4769 15.0181 84.7847 19.0526 84.7847Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5282 52.086V63.9143L65.2167 61.7752V49.8839L61.5282 52.086Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M62.668 59.8787V61.6134L64.0769 60.8314V59.0338L62.668 59.8787Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5103 47.9695V59.7708L61.5282 63.9144V52.086L54.5103 47.9695Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2167 49.8839L58.2077 45.7584L54.5103 47.9695L61.5282 52.086L65.2167 49.8839Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8308 54.2881V66.0805L61.5282 63.9143V52.086L57.8308 54.2881Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9705 62.0538V63.7885L60.3795 63.0065V61.2089L58.9705 62.0538Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8218 50.1626V61.946L57.8308 66.0805V54.2881L50.8218 50.1626Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5282 52.086L54.5103 47.9695L50.8218 50.1626L57.8308 54.2881L61.5282 52.086Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1423 56.4812V68.2646L57.8308 66.0805V54.2791L54.1423 56.4812Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M55.282 64.2469V65.9816L56.691 65.1907V63.393L55.282 64.2469Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1244 52.3467V64.1391L54.1423 68.2646V56.4812L47.1244 52.3467Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8308 54.2791L50.8218 50.1626L47.1244 52.3467L54.1423 56.4812L57.8308 54.2791Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M47.959 60.1843V71.9767L51.6564 69.8195V57.9912L47.959 60.1843Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1077 67.959V69.6847L50.5167 68.9027V67.1051L49.1077 67.959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M40.95 56.0587V67.8511L47.959 71.9767V60.1843L40.95 56.0587Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40.95 56.0587V67.8511L47.959 71.9767V60.1843L40.95 56.0587Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6564 57.9912L44.6474 53.8657L40.95 56.0588L47.959 60.1843L51.6564 57.9912Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.632 74.1518V79.9581L44.5577 74.1698V68.2466L34.632 74.1518Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6513 74.5203V76.4797L42.5385 73.0462V71.0239L36.6513 74.5203Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0692 67.986V73.8013L34.6321 79.9581V74.1518L24.0692 67.986Z",
    fill: "#DEDEDE",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5577 68.2466L33.9949 62.0988L24.0692 67.986L34.632 74.1518L44.5577 68.2466Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 75.8056L69.5872 45.1832V43.6732L0.421791 64.4357V65.9457L17.1051 75.8056Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1051 74.2956L69.5872 43.6731L52.9038 33.8132L0.421791 64.4357L17.1051 74.2956Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0.421791 65.9457L17.1051 75.8056V148.717L0.421791 138.866V65.9457Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8987 32.2043L43.6064 32.3571C43.6064 32.3571 45.1859 43.9698 45.1859 46.1089C45.1859 48.0953 48.1923 49.7042 51.8987 49.7042C55.6051 49.7042 58.6205 48.0863 58.6205 46.1089C58.6205 43.9698 60.191 32.3571 60.191 32.3571L51.8987 32.2043Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8987 36.7793C56.4784 36.7793 60.191 34.7874 60.191 32.3302C60.191 29.873 56.4784 27.8811 51.8987 27.8811C47.319 27.8811 43.6064 29.873 43.6064 32.3302C43.6064 34.7874 47.319 36.7793 51.8987 36.7793Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8987 36.7793C55.3449 36.7793 58.2974 35.6558 59.5538 34.0829C59.0962 32.0336 55.8474 30.4427 51.8987 30.4427C47.95 30.4427 44.7192 32.0336 44.2526 34.0829C45.509 35.6558 48.4615 36.7793 51.8987 36.7793Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5423 32.5369C47.3676 29.0502 45.2184 25.9743 42.35 23.6747C41.1026 22.7758 45.5987 23.2702 48.4346 25.2206C47.7494 22.0016 46.5622 18.9107 44.9167 16.0617C44.1897 14.8394 47.3308 16.0617 49.0269 18.2638C48.8412 16.2975 48.2286 14.3956 47.2321 12.6912C46.6756 11.7924 50.5436 14.4888 50.5436 14.4888C50.5436 14.4888 49.4846 9.64423 47.5641 6.88489C46.9269 5.98608 49.5564 6.60626 50.5436 8.88025C50.5436 8.88025 51.2526 2.1931 51.9615 0.790959C52.6705 -0.611184 53.3885 8.18816 53.3885 8.18816C54.109 7.54681 54.9231 7.01942 55.8026 6.62423C56.9423 6.1928 54.7795 9.32066 53.9269 13.5541C54.9669 12.5546 56.2096 11.7913 57.5705 11.316C58.7103 11.0284 55.1564 12.5923 54.3038 19.0008C55.3317 17.6478 56.4922 16.4012 57.768 15.2798C58.5397 14.7135 55.8385 19.63 55.6949 24.8521C55.6949 24.8521 59.5359 22.2455 60.9538 21.9669C62.3718 21.6883 56.6821 26.0655 55.2731 31.8538C54.7885 33.8492 54.0795 34.8828 52.0603 34.8828C51.2951 34.9498 50.5299 34.754 49.8906 34.3277C49.2512 33.9013 48.7757 33.2698 48.5423 32.5369V32.5369Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf);
export default __webpack_public_path__ + "static/media/Bookshelf.57b98b4a230982fd0152a8bfe917ae29.svg";
export { ForwardRef as ReactComponent };